import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';



@Component({
  selector: 'app-autoclaim',
  templateUrl: './autoclaim.component.html',
  styleUrls: ['./autoclaim.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],

})

export class AutoclaimComponent implements OnInit {

  columnsToDisplay = ['claimtype', 'billingprovider', 'pos', 'Action'];
  headercolumnsToDisplay = ['Claim Type', 'Billing Provider', 'POS', 'Action'];
  public show: boolean = false;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }


  autoclaimform: FormGroup;
  submitted = false;


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.autoclaimform = this.formBuilder.group({


      claimtype: ['',],
      billingprovider: ['',],
      pos: ['',],
      claimtypes: ['',],
      billingproviders: ['',],
      poss: ['',],



    });


  }

  get f() { return this.autoclaimform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.autoclaimform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.autoclaimform.value))
  }
}


